import getConversationReadingPaneViewState from './getConversationReadingPaneViewState';
import isItemView from 'owa-mail-store/lib/utils/isItemView';
import { CalendarViewDetails } from '../schema/CalendarViewDetails';
import { getItemReadingPaneViewState } from './getItemReadingPaneViewState';
/**
 * Selector to get the calendarViewDetails from the store
 */
export const getCalendarViewDetails = (): CalendarViewDetails => {
    const viewState = isItemView()
        ? getItemReadingPaneViewState()
        : getConversationReadingPaneViewState();

    return viewState?.calendarViewDetails || {};
};
